import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'
import moment from 'moment'

import { Modal, Form, Input, Button, Spin, Select, message, DatePicker,Radio,InputNumber } from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

const {TextArea} = Input
const {Option} = Select

export default function UserCoinDateEditModal (props) {
  const userData = useSelector(state => state.user.value)
  const metadata = useSelector(state => state.metadata.value)
  const {userCoinDateId,visible, onOk, onCancel} = props
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [userCoinDate, setUserCoinDate] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        console.dir(userCoinDateId)
        const userCoinDateRes = await ToolRequest.request('GET', `/user-coin-date/${userCoinDateId}`)
        if(userCoinDateRes.data.expiredAt){
          userCoinDateRes.data.expiredAt = moment(userCoinDateRes.data.expiredAt).utcOffset(metadata.utcOffset)
        }
        console.dir(userCoinDateRes)
        setUserCoinDate(userCoinDateRes.data)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    console.dir(values)
    try {
      let expiredAt = null
      if(values.expiredAt){
        expiredAt = moment(values.expiredAt).utcOffset(metadata.utcOffset).format('YYYY-MM-DD')
      }
      const data = {
        expiredAt,
      }
      await ToolRequest.request('PUT', `/user-coin-date/${userCoinDateId}`, data)
      message.success(I18n.t('editSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('編輯用戶積分')}
      open={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={userCoinDate}
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('到期日')}
              name="expiredAt"
              rules={[
                {
                  required: true
                },
              ]}
            >
              <DatePicker
                placeholder={I18n.t('到期日')}
              />
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};